import { FC, memo, useEffect } from "react";
import GuestLayout from "./guest-layout";
import AuthorizedLayout from "./authorized-layout";
import Theme from "common/components/base/theme/Theme";
import { useAppDispatch } from "common/redux/core/root.reducer";
import { AuthService } from "common/services/auth.service";
import { useIsAuthenticated } from "@azure/msal-react";
import { userActions } from "common/redux/user";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "common/config";
import useAuthMode from "common/hooks/useAuthMode";

type LayoutProps = {
  //isAuthenticated: boolean;
};
const Layout: FC<LayoutProps> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthMode();
  // const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && window.location.hash) {
      AuthService.setRedirectUrl(window.location.hash);
    }
    if (isAuthenticated) {
      console.log("Authenticated");
      const redirectUrl = AuthService.getRedirectUrl();
      if (redirectUrl !== `#/${MainRoutes.HOME}`) {
        AuthService.clearRedirectUrl();
        navigate(redirectUrl.replace(/^#/, ""), { replace: true });
      }
      window.history.replaceState(
        window.history.state || {},
        document.title,
        `${window.location.origin}${redirectUrl}`
      );
    }
  }, [isAuthenticated]);

  return (
    <>
      <Theme variant="light" />
      {isAuthenticated ? <AuthorizedLayout /> : <GuestLayout />}
    </>
  );
};

export default memo(Layout);
